/* eslint-disable no-alert */
import React, { useContext, useEffect, useState } from 'react';
import merge from 'lodash.merge';

import LocationLabel from '../../../../components/locationLabel';
import ConditionRatingBar from "../../../../components/conditionRatingBar";
import AssetDetails from "../../assetDetail";

import ICONS from '../../../../assets/icons';
import COLORS from '../../../../assets/styles/config/colors';

import { ActiveArrow, BtmCtn, CardBody, CardCtn, DropdownJobDetailCtn, JobTitle, TopCtn } from './index.style';
import AssetListContext from "../../../context/assetListContext";
import useTextCorrection from "../../../../hooks/useTextCorrection";
import Asset from "../../../interfaces/asset";

interface CardProps {
  assetDetails: Asset;
  location?: string;
}

const Card: React.FC<CardProps> = ({ assetDetails, location, clickControl }): React.ReactElement => {
  const { openAssetDetails, selectedAsset, updateOpenAssetDetails, setAssetDetails, clearAssetDetails } = useContext(AssetListContext);

  const [ rating, setRating ] = useState('');
  const [cardColors, setCardColors] = useState({
    activeBorder: COLORS.slaSecondary.upcoming,
    border: COLORS.slaPrimary.upcoming,
    shadow: COLORS.slaShadow.upcoming,
  });

  const { filterNumber } = useTextCorrection();

  useEffect(() => {
    setRating(assetDetails.Condition)
     if (assetDetails.Condition =='3 (MODERATE)') {
      setCardColors({
        activeBorder: COLORS.slaSecondary.upcomingToday,
        border: '#FBE019',
        shadow: COLORS.slaShadow.upcomingToday,
      });
    } else if (assetDetails.Condition == '1 (VERY GOOD)') {
      setCardColors({
        activeBorder: COLORS.slaSecondary.doneOnTime,
        border: COLORS.slaPrimary.doneOnTime,
        shadow: COLORS.slaShadow.doneOnTime,
      });
    } else if(assetDetails.Condition == '2 (GOOD)') {
       setCardColors({
         activeBorder: COLORS.slaSecondary.doneOnTime,
         border: "#6BD45B",
         shadow: COLORS.slaShadow.doneOnTime,
       });
    } else if (assetDetails.Condition == '4 (POOR)') {
      setCardColors({
        activeBorder: COLORS.slaSecondary.urgentlyUpcoming,
        border: COLORS.slaPrimary.urgentlyUpcoming,
        shadow: COLORS.slaShadow.urgentlyUpcoming,
      });
    } else if(assetDetails.Condition == '5 (VERY POOR)') {
       setCardColors({
         activeBorder: COLORS.slaSecondary.missedDeadline,
         border: "#EF2015",
         shadow: COLORS.slaShadow.missedDeadline,
       });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetDetails.Condition]);

  const handleClick = () => {
    let newAssetDetail = {...assetDetails};
    if (location === 'assets') {
      if (openAssetDetails && selectedAsset.SerialNo === assetDetails.SerialNo) {
        updateOpenAssetDetails(false);
      } else {
        updateOpenAssetDetails(true);
      }
      if(assetDetails.Condition == undefined) newAssetDetail = merge(newAssetDetail,{Condition: 0});
      clearAssetDetails();
      setAssetDetails({ selectedAsset: newAssetDetail });
    }
    if(location == 'reactive' || location == 'planned') {
      clickControl();
      clearAssetDetails();
      setAssetDetails({ selectedAsset: newAssetDetail });
    }
  };

  return (
    <React.Fragment>
      <CardCtn>
        <CardBody
          active={selectedAsset.SerialNo === assetDetails.SerialNo}
          cardBorder={cardColors.border}
          cardActiveBorder={cardColors.activeBorder}
          cardShadow={cardColors.shadow}
          onClick={(e): void => {
            e.preventDefault();
            handleClick();
          }}
        >
          <TopCtn>
            <JobTitle>{assetDetails.ItemDescription}</JobTitle>
            <ConditionRatingBar selectedRating={assetDetails.Condition} search={false}/>
          </TopCtn>
          <BtmCtn>
            <LocationLabel location={assetDetails.SerialLocationText == ""? assetDetails.ContractSiteDesc : assetDetails.SerialLocationText} />
          </BtmCtn>
          <ActiveArrow
            active={selectedAsset.SerialNo === assetDetails.SerialNo}
            home={location === 'HOME'}
            cardBorder={cardColors.border}
          >
            <ICONS.chevronRight />
          </ActiveArrow>
        </CardBody>
      </CardCtn>
      <DropdownJobDetailCtn active={selectedAsset.SerialNo === assetDetails.SerialNo}>
        {window.innerWidth<1440 && location=='assets' && openAssetDetails && selectedAsset.SerialNo==assetDetails.SerialNo && <AssetDetails/>}
      </DropdownJobDetailCtn>
    </React.Fragment>
  );
};

export default Card;
